<div class="footer__{{ footerLocation }}-container {{ alignClass }} {{ flexDirection }} flex">
  @for (link of links; track link; let first = $first) {
    <a
      class="{{ footerLocation === 'bottom' ? (first ? 'mr-3 md:w-1/2 lg:w-auto' : 'md:w-1/2 lg:w-auto') : '' }} py-1 text-sm leading-6 hover:text-ace-teal-500 flex {{ layout }} {{ linkClass }}"
      [href]="link.linkUrl"
      [attr.target]="link.newTab ? '_blank' : null"
      [attr.nofollow]="link.nofollow"
      [attr.aria-label]="!getAriaLabelledbyAndContext(link.linkUrl) ? (link.linkText + (link.newTab ? ' (opens in a new tab)' : '')) : null"
      [attr.aria-labelledby]="getAriaLabelledbyAndContext(link.linkUrl) ? accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label' : null"
      >
      @if (link.icon) {
        <fa-icon
          class="mr-3 h-4 w-4 self-center -mt-1 justify-self-end fa-1x"
          [icon]="[iconPrefix, link.icon]"
        ></fa-icon>
      }
      <span class="xs:inline mt-2" [class.hidden]="footerLocation === 'social'">{{ link.linkText }}</span>
      <!-- Hidden Context -->
      @if (getAriaLabelledbyAndContext(link.linkUrl)) {
        <span [attr.id]="accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(link.linkUrl, link.linkText)}}</span>
      }
    </a>
  }
</div>